import { Promotion } from '@interfaces'
import { api } from '@utils/api/api'

export const getPromotions = (isTester: boolean): Promise<Promotion[]> => {
  return api.get(`/api/v1/promotions?accessLevel=${isTester ? 'beta' : 'user'}`)
}
